import React, { useState } from 'react'
import ResultsSection, { NotAvailable } from './ResultsSection'
import useTranslation from '../shared/TranslationProvider'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '~/lib/ui/dialog'
import { Button } from '~/lib/ui/button'

const TraitsSection = ({ career, ...props }) => {
  const { personality_traits } = career
  const traitSections = [
    'most_important',
    'significantly_important',
    'less_important',
  ]
  const noTraits =
    !personality_traits[0]?.length &&
    !personality_traits[1]?.length &&
    !personality_traits[2]?.length
  if (!personality_traits.length || noTraits)
    return <NotAvailable section="traits" career={career} {...props} />
  return (
    <ResultsSection section="traits" career={career} {...props}>
      <div className="flex flex-col gap-4 pt-4">
        {personality_traits.map((traits, idx) => (
          <TraitSection
            key={`traits-${idx}`}
            traitSection={traitSections[idx]}
            traits={traits}
          />
        ))}
      </div>
    </ResultsSection>
  )
}

export default TraitsSection

const TraitSection = ({ traitSection, traits }) => {
  const { t } = useTranslation('traits')
  const showTraits = traits.length > 0
  return (
    showTraits && (
      <div>
        <div className="subtitle">{t(traitSection)}</div>
        <ul className="list-disc pl-6">
          {traits.map((trait, idx) => (
            <li key={`${traitSection}-${idx}`} title={trait.description}>
              <TraitDialog trait={trait}>{trait.name}</TraitDialog>
            </li>
          ))}
        </ul>
      </div>
    )
  )
}

const TraitDialog = ({ trait, children }) => {
  const [isOpen, setIsOpen] = useState(false)
  const toggleDialog = () => {
    setIsOpen(!isOpen)
  }
  const { name, details } = trait
  return (
    <Dialog open={isOpen} onOpenChange={toggleDialog}>
      <DialogTrigger asChild>
        <Button variant="link">{children}</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{name}</DialogTitle>
        </DialogHeader>
        <div className="flex items-center justify-center p-8">{details}</div>
      </DialogContent>
    </Dialog>
  )
}
